import axios from '../axios.js'

var userInfo = {
    // 个人信息
    getEmployeeInfo: function (data, success, failure) {
        return axios.get('/employee/getEmployeeInfo', data, success, failure)
    },
    // 修改用户信息
    updateEmployeeInfo: function (data, success, failure) {
        return axios.postJson('/employee/updateEmployeeInfo', data, success, failure)
    },
    // 修改密码
    updatePass: function (data, success, failure) {
        return axios.post('/employee/updatePass', data, success, failure)
    },
    // 获取技能筛选列表
    getSkills: function (data, success, failure) {
        return axios.get('/employee/getSkills', data, success, failure)
    },
    // 获取用户技能列表
    getUserSkills: function (data, success, failure) {
        return axios.get('/employee/getUserSkills', data, success, failure)
    },
    // 获取用户工作量
    getMyWorkload: function (data, success, failure) {
        return axios.get('/employee/getMyWorkload', data, success, failure)
    },
    //资讯接口
    getNews: function (data, success, failure) {
        return axios.get('/news/getNews', data, success, failure)
    },
    // 获取消息通知设定
    getEmployeeNoticeSetting: function (data, success, failure) {
        return axios.get('/employee/getEmployeeNoticeSetting', data, success, failure)
    },
    // 修改消息通知设定
    updateNoticeSetting: function (data, success, failure) {
        return axios.post('/employee/updateNoticeSetting', data, success, failure)
    },
    // 获取我的活动列表
    getOperateLogs: function (data, success, failure) {
        return axios.get('/operateLog/getOperateLogs', data, success, failure)
    },
    //项目活动记录
    getProjectTaskOperateLogs: function (data, success, failure) {
        return axios.get('/operateLog/getProjectTaskOperateLogs', data, success, failure)
    },
    //项目面板活动记录
    getTaskBoardOperateLogs: function (data, success, failure) {
        return axios.get('/operateLog/getTaskBoardOperateLogs', data, success, failure)
    },

    // 获取用户项目列表
    getUserProjects: function (data, success, failure) {
        return axios.get('/operateLog/getUserProjects', data, success, failure)
    },

    /**
     * 注册/登录
     */
    // 注册用户
    register: function (data, success, failure) {
        return axios.postJson('/employee/register', data, success, failure)
    },
    // 登录
    login: function (data, success, failure) {
        return axios.post('/login/login', data, success, failure)
    },

    //发送短信
    sendSMS: function (data, success, failure) {
        return axios.post('/login/sendSMS', data, success, failure)
    },
    // 检查邮箱并发送邮件
    checkEmail2Send: function (data, success, failure) {
        return axios.post('/login/checkEmail2Send', data, success, failure)
    },
    // 修改密码
    updatePassword: function (data, success, failure) {
        return axios.post('/login/updatePassword', data, success, failure)
    },
    /*
      * 申请企业
    */
    // 获取行业列表
    getIndustrys: function (data, success, failure) {
        return axios.get('/employee/getIndustrys', data, success, failure)
    },
    // 企业申请入驻
    applyCompany: function (data, success, failure) {
        return axios.postJson('/employee/applyCompany', data, success, failure)
    },

    /**
     * 企业微信登录
     */
    qyvxLogin: function (data, success, failure) {
        return axios.post('/qyvx/qyvxLogin', data, success, failure)
    },
    /**
     * 绑定企业微信
     */
    bindQyvx: function (data, success, failure) {
        return axios.post('/qyvx/bindQyvx', data, success, failure);
    },

    // 获取企业微信ticket
    getJsapiTicket: function (data, success, failure) {
        return axios.get('/qyvx/getJsapiTicket', data, success, failure);
    },
    /**
     * 绑定微信
     */
    wxBind: function (data, success, failure) {
        return axios.post('/wx/wxBind', data, success, failure);
    },
    wxLogin: function (data, success, failure) {
        return axios.post('/wx/wxLogin', data, success, failure);
    },


    checkVersion: function (data, success, failure) {
        return axios.post('/sysVersion/checkVersion', data, success, failure);
    },
    loginByValidCode: function (data, success, failure) {
        return axios.post('/v2/employee/loginByValidCode', data, success, failure);
    },

    /**
     * 获取用户消息通知配置列表
     */
    getNoticeTypes: function (data, success, failure) {
        return axios.get('/v2/noticeType/getNoticeTypes', data, success, failure);
    },

    /**
     * 修改消息通知配置
     */
    updateNoticeType: function (data, success, failure) {
        return axios.post('/v2/noticeType/updateNoticeType', data, success, failure);
    },

}

export default userInfo
